/* eslint-disable max-len */
import { useIsMount } from 'Hooks/useIsMount';
import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { setOffline } from 'Redux/modules/ui/actions';
import { Button } from 'semantic-ui-react';

import { setToastPosition } from '../redux/modules/ui/actions';

import styles from './OfflineCheck.less';

const OnlineStatus = () => (
  <div className={styles.container}>
    <svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg">
      <g fill="#2ECC71" fillRule="nonzero">
        <path d="m5.142 9.285 1.286 1.286a5.057 5.057 0 0 1 7.144 0l1.286-1.286c-2.68-2.677-7.037-2.678-9.716 0z" />
        <path d="m2.571 6.713 1.286 1.285c3.387-3.385 8.898-3.386 12.287 0l1.285-1.285c-4.097-4.096-10.762-4.095-14.858 0z" />
        <path d="m0 4.142 1.286 1.286C6.09.623 13.91.623 18.714 5.428L20 4.142c-5.522-5.521-14.475-5.524-20 0z" />
        <circle cx="10" cy="13.182" r="1.364" />
      </g>
    </svg>
    <div>Your internet connection was restored.</div>
  </div>
);

const OfflineStatus = () => (
  <div className={styles.container}>
    <svg width="20" height="17" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
      <g fill="#FFF" fillRule="nonzero" opacity=".407">
        <path d="M11.364 15a1.364 1.364 0 1 1-2.728 0 1.364 1.364 0 0 1 2.728 0zM16.143 9.819 17.43 8.53a10.455 10.455 0 0 0-5.457-2.885l4.171 4.173zM9.97 3.644a12.286 12.286 0 0 1 8.744 3.602L20 5.96c-3.204-3.203-7.562-4.536-11.736-4.022L9.97 3.644zM3.754 0 2.468 1.285l1.769 1.769A14.049 14.049 0 0 0 0 5.96l1.285 1.286a12.23 12.23 0 0 1 4.345-2.8L7.072 5.89a10.4 10.4 0 0 0-4.5 2.642l1.284 1.287A8.6 8.6 0 0 1 8.594 7.41L10.29 9.11a6.846 6.846 0 0 0-5.149 1.994l1.286 1.286a5.056 5.056 0 0 1 7.144 0l2.156 2.156 1.285-1.285L3.753 0z" />
      </g>
    </svg>
    <div>You are currently offline.</div>
    <Button
      compact
      className={styles.btnRefresh}
      onClick={() => {
        window.location.reload();
      }}>
      Refresh
    </Button>
  </div>
);

const OfflineCheck = () => {
  const isMount = useIsMount();
  const dispatch = useDispatch();
  const { offline } = useSelector(state => state.ui);
  const handleOffline = () => {
    dispatch(setToastPosition('bottom-left'));
    dispatch(setOffline(true));
  };

  const handleOnline = () => {
    dispatch(setToastPosition('bottom-left'));
    dispatch(setOffline(false));
  };

  useEffect(() => {
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
  }, []);

  useEffect(() => {
    if (!isMount) {
      toast.custom(offline ? <OfflineStatus /> : <OnlineStatus />, { position: 'bottom-left' });
    }
  }, [offline]);

  return <div />;
};

export default OfflineCheck;
